itsoftApp.createModule('scrollEffects', ['windowScroll', 'slidersSettings'], function () {
  var module = this;

  function ScrollEffects(self, classAnimate, oldClass, obj, callBack) {
    this._self = self;
    this._classAnimate = classAnimate;
    this._obj = obj;
    this._callBack = callBack;
    this._scrollPoint;
    this._oldClass = oldClass;
    this.init();
  }

  ScrollEffects.prototype.init = function () {
    var self = this;
    var scrollPos = 0; // Для первоначального определения позиции

    /**
     * Функция, которая скрывает/показывает header в зависимости от скролла вниз или вверх
     * Условия такие: position < scrollPos - значит вниз, а наоборот - наверх.
     * Если мы скроллим вниз и уже прошли более 200 пикселей и у Header
     * нет скрывающего класса - значит мы его добавляем
     */
    function scrollEvent(scrolled) {
      var header = document.querySelector('.js-page-header');
      var toUpButton = document.querySelector('.js-to-up-button');
      var scrollClass = 'page-header--scroll-hide';
      var toUpButtonClass = 'to-up-button--scroll-show';
      var position = (document.body.getBoundingClientRect()).top;

      /**
       * Скролл для header
       */
      if (header) {
        if (position < scrollPos &&
          scrolled > 200 &&
          !header.classList.contains(scrollClass)) {
          //to down
          header.classList.add(scrollClass);
        } else if (position > scrollPos &&
          header.classList.contains(scrollClass)) {
          // to up
          header.classList.remove(scrollClass);
        }
        // saves the new position for iteration.
        scrollPos = position;
      }

      /**
       * Скролл для значка вверх
       */
      if (toUpButton) {
        if (scrolled > 1000 && !toUpButton.classList.contains(toUpButtonClass)) {
          toUpButton.classList.add(toUpButtonClass);
        }

        if (scrolled < 1000 && toUpButton.classList.contains(toUpButtonClass)) {
          toUpButton.classList.remove(toUpButtonClass);
        }
      }
    }

    function show(scroll, number) {
      var scrolled = pageYOffset;
      var coeff;

      scrollEvent(scrolled);

      if (number) {
        coeff = number;
      } else {
        coeff = 1.3;
      }

      self._scrollPoint = parseInt(self._self.getBoundingClientRect().top);
      // console.log(scrolled + window.innerHeight / 2  + " " + (self._scrollPoint + scrolled));
      if (scrolled + window.innerHeight / coeff >= (self._scrollPoint + scrolled)) {
        self.fadeIn();
      }
    }

    show('auto', 1);

    itsoftApp.modules.windowScroll.addEvent(show);
  };

  ScrollEffects.prototype.fadeIn = function () {
    if (typeof this._callBack === 'function') {
      this._callBack.call(this._obj);
    } else {
      if (this._oldClass) {
        this._self.classList.remove(this._oldClass);

        /** NOTE: Убрал загрузку слайдеров по скроллу.
         * Вместо этого создал модуль, который грузит слайдеры при загрузке страницы, называется loadingSliders
         */
        // if (this._self.classList.contains('js-slider')) {
        //     var sliderSettingsKey = this._self.getAttribute('data-slider-settings'); // получаем data-атрибут
        //     var {sliderSettingsObject} = itsoftApp.modules.slidersSettings; // получаем объект конфига (общий)
        //     var params = sliderSettingsObject[sliderSettingsKey]; // Объект params, содержит любые поля + params с конфигом
        //
        //     if (sliderSettingsKey && params) {
        //         itsoftApp.modules.slidersLibrary.callback(this._self, {sliderSettings: params.params});
        //     } else {
        //         itsoftApp.modules.slidersLibrary.callback(this._self);
        //     }
        // }

        if (this._self.classList.contains('js-accordion')) {
          itsoftApp.modules.accordion.callback(this._self);
        }

        this._oldClass = undefined;
      }
      this._self.classList.add(this._classAnimate);
    }
  };

  module.ScrollEffects = ScrollEffects;

});
